





















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from 'vue-property-decorator';

// Shared types
import { Company, Map, System as ISystem } from '@coldtec/cos-types';

// Store types
import { SystemsGetter, SystemsState, ToolSystem, ToolSpace } from '@/store/store.types';

// System tile
import System from './system/System.vue';

/**
 *  Holding the details of the no suggestions tile, show when
 *  there are no suggestions available for the showing space.
 */
interface NoSuggestionsTile {
    /** The title of the no suggestions tile. */
    title: string;

    /** The message of the no suggestions tile. */
    message: string;
}

/**
 *  Component that renders all the suggested systems for the currently showing space(s).
 */
@Component({
    components: {
        System,
    },
})
export default class SystemsSuggestions extends Vue {

    /**
     *
     *  Used to toggle the selected state of a system (for the current showing space).
     *
     *  @param systemGuid The guid of the system to toggle
     *
     */
    @Inject('toggleSystem')
    private toggleSystem!: (systemGuid: string) => void;

    /**
     *  Used to get the system's state from the store.
     */
    private get systemsState(): SystemsState {

        return this.$store.state.systems;

    }

    /**
     *  Used to get all the systems that were suggested from the store.
     */
    private get suggestedSystems(): Map<ISystem> {

        return this.$store.getters[SystemsGetter.SUGGESTIONS_SYSTEMS];

    }

    /**
     *  Used to get all the tool systems that were suggested for the currently showing space.
     */
    private get systemSuggestions(): Array<ToolSystem> {

        return this.$store.getters[SystemsGetter.SUGGESTIONS_OF_SHOWING_SPACE];

    }

    /**
     *  Used to get the filter's active state out of the store.
     */
    private get filtersActive(): boolean {

        return this.$store.getters[SystemsGetter.FILTER_ACTIVE];

    }

    /**
     *  Used to get the interpolated title and message
     *  of the no suggestions tile.
     */
    private get noSuggestionsTile(): NoSuggestionsTile {

        /**
         *  Get the spaces for which the no suggestion tool is currently showing.
         */
        const spaces: Array<ToolSpace> = this.$store.getters[SystemsGetter.SPACES];

        /**
         *  Get the data of the company for which the tool is currently used.
         */
        const company: Company = this.$store.state.company.details;

        /**
         *  Construct the default title and message.
         */
        const title = 'Geen standaard systemen';
        let message = 'Helaas zijn er geen standaard systemen voor ruimtes met een inhoud van';

        /**
         *  Interpolate the content of every space for
         *  which the no suggestion tile is shown.
         */
        spaces.forEach((space: ToolSpace, index: number) => {

            message += index !== spaces.length - 1 ? ' en, ' : ' ';
            message += `${ space.data.contents } m³`;

        });

        /**
         *  Add the contact details of the company for which
         *  the tool is currently being used to the message.
         */
        message += `. <br />Natuurlijk helpen we graag met een oplossing, dus bel <a class="ccos-link ccos-link--external" href="tel:${ company.formatted_phone_number }">${ company.phone_number }</a> of mail naar <a class="ccos-link ccos-link--external" href="mailto:${ company.email }">${ company.email }</a> voor advies of een offerte op maat.`;

        return { title, message };

    }

}
